export default __webpack_public_path__ + "static/media/100_73478.3670afe7.jpg";